import React from 'react';

import Alert from './index.js';

const ErrorAlert = props => {
  return <Alert type="error" {...props} />;
};

export default ErrorAlert;
